import { Outlet } from "react-router-dom";
import MobileDH from "../components/MobileDH";
import Sidebar from "../components/Sidebar"
import useMenu from "../useMenu";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react"

function Dashboard() {
  const {showMenu, CloseMenu, OpenMenu} = useMenu();
  const { username, token } = useParams();
  const [paylink, setpayLink] = useState('');
  const [Bal, setBal] = useState('');
  const [trans, setTrans] = useState([]);
  const [fullname, setfullname] = useState('');

  const getPayLink = async (username,token) => {
    const linkOptions = {
      method: 'GET',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` },
  };
    await fetch(`${process.env.REACT_APP_API_URL}/dashboard/payment-link/${username}`, linkOptions)
    .then (response => response.json())
    .then (data =>{
      if(data){
        const newPayLink = JSON.parse(data.paymentLink);
        const profilename = data.user.firstname + " " + data.user.lastname
        setpayLink(newPayLink)
        setfullname(profilename)
        // console.log(data, ProfileName)
      }
    })
      .catch(err => console.log(err))
}
  const getBal = async (username,token) => {
    const linkOptions = {
      method: 'GET',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` },
  };
    await fetch(`${process.env.REACT_APP_API_URL}/dashboard/available-balance/${username}`, linkOptions)
    .then (response => response.json())
    .then (data =>{
      if(data){
        // console.log(data.availableBalance)
        const newBal = JSON.parse(data.availableBalance);
        setBal(newBal)
      }
    })
      .catch(err => console.log(err))
}
  const getTrans = async (username,token) => {
    const linkOptions = {
      method: 'GET',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` },
  };
    await fetch(`${process.env.REACT_APP_API_URL}/dashboard/recent-transactions/${username}`, linkOptions)
    .then (response => response.json())
    .then (data =>{
      if(data){
        if (data.transactions.length){
          setTrans(data.transactions)

        } else {
          setTrans(false)
        }
        
      }
    })
      .catch(err => console.log(err))
}


    useEffect(()=>{
      getPayLink(username,token)
      getBal(username,token)
      getTrans(username,token);
    },[username, token]);


  return (
    <div className="dashboard-container">
      <Sidebar onClick={CloseMenu} className={showMenu ? "sidebar-container open-menu" : "sidebar-container"}/>
      <div className={showMenu ? "dashboard-main menu-open" : "dashboard-main"}>
        <MobileDH  onClick={OpenMenu} profilename={fullname}/>
        <Outlet context={[paylink, Bal, username, fullname, trans]} />
      </div>
      
    </div>
  )
}

export default Dashboard
